import * as Constant from './constant';

export const initialState = { totalCount: 0, data: [], loading: false, error: false };

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constant.LIST_NOTIFICATION:
      return {
        ...state,
        loading: true,
        data: [],
        error: false,
      };
    case Constant.LIST_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        totalCount: action.payload.total,
        data: action.payload.notificationreports,
        error: false,
      };
    case Constant.LIST_NOTIFICATION_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        error: true,
      };


    default:
      return state;
  }
};

export default notificationReducer;
